<template>
  <div class="work-detail">
    <el-dialog
      :title="data.title"
      top="15%"
      :visible.sync="dialogVisible"
      width="850px"
      @close="close"
      center>
      <div @click="share()" class="shareText">
        <div>分享</div>
        <img src="../../../assets/images/read.png"/>
      </div>
      <div class="work-detail-ct">
        <div class="info-center pr">
          <img src="" alt="">
          <span v-if="data.article === '行业动态'">{{data.publishUserName}}</span>
          <span v-else>{{data.updator}}</span>
          <span class="time">{{format(data.publishTime)}}</span>
          <span class="article pa">{{data.article}}</span>
        </div>
        <div class="work-content" v-html="data.content"></div>
        <el-dialog
          title="| 链接分享"
          :visible.sync="innerVisible"
          width="580px"
          append-to-body>
          <span>我的链接：</span>
          <template v-if="data.article === '行业动态'">
            <input type="text" class="link-share" v-model="message + data.id"/>
          </template>
          <template v-if="data.article === '企业动态'">
            <input type="text" class="link-share" v-model="link + data.id"/>
          </template>
          <button
            v-clipboard:copy="message + data.id"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            class="copy"
          >复 制</button>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import Api from '@/api/customer-good'
  import Moment from 'moment'
  export default {
    props: {
      visible: {
        type: Boolean
      },
      data: {
        type: Object
      }
    },
    watch: {
      visible () {
        this.dialogVisible = this.visible
      }
    },
    data () {
      return {
        innerVisible: false,
        message: 'https://www.qudao51.com/#/industry-details?id=',
        link: 'https://www.qudao51.com/#/about-details?id=',
        dialogVisible: this.visible
      }
    },
    methods: {
      close () {
        this.$emit('update:visible', false)
      },
      format (val) {
        return Moment(val, 'YYYYMMDD').format('YYYY-MM-DD')
      },
      share () {
        this.innerVisible = true
      },
      onCopy (e) {
        this.visible = false
        Api.sharese(response => {
          let status = response.status || 0
          if (status === 200 || status === 204) {
            this.$message.success('复制成功，请把链接分享给他人' || e.text)
          } else {
            this.$message.error('分享失败')
          }
        })
      },
      onError (e) {
        this.$message.success('复制失败，请手动复制')
      }
    }
  }
</script>
<style scoped lang="scss">
  .shareText{
    float: right;
    z-index: 999;
    top: -44px;
    left: 750px;
    position: absolute;
    cursor: pointer;
    color: #085ecc;
    >div{
      float: left;
      font-size: 14px;
      margin-right: 5px;
    }
    >img{
      float: left;
      margin-top: 3px;
    }
  }
  .link-share{
    width: 350px;
    height: 35px;
    border-radius: 4px;
    border: 1px solid #999;
    font-size: 14px;
    text-indent: 10px;
  }
  .copy{
    width: 100px;
    height: 40px;
    border-radius: 4px;
    border: none;
    outline: none;
    color: white;
    background: #085ECC;
    cursor: pointer;
    &:hover {
      background: #4a98ff;
      transition-duration: 0.5s;
    }
  }
  .work-detail{
    &-ct{
      .info-center{
        height:70px;
        text-align: center;
        line-height:70px;
        margin-bottom:30px;
        margin-top: -14px;
        border-bottom:1px solid #EEEEEE;
        .time{margin-left:15px;}
        .article{
          right:0;
        }
      }
    }
  }
</style>
<style lang="scss">
  .work-detail{
    .el-dialog__header{
      padding: 40px 0 0 78px;
    }
    .el-dialog__title{
      font-weight:600;
      line-height: 26px;
      font-size: 18px;
      color: #303133;
      display: block;
      width: 664px;
      height: 60px;
      letter-spacing: 0.5px;
    }
    .el-dialog--center .el-dialog__body{padding:0 75px 20px;position: relative;}
    .work-content{
      padding-bottom: 40px;
      box-sizing: border-box;
      img{width:100%;}
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/common/WorkDetails.vue